import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';

import { OrderDetailModule } from './order-detail/order-detail.module';
import { OrderListModule } from './order-list/order-list.module';

@NgModule({
  imports: [OrderListModule, OrderDetailModule, FuseSharedModule],
  declarations: [],
})
export class OrderModule {}
